import React, { useState, useEffect, useCallback, useRef } from 'react';

const Gallery = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const carouselRef = useRef(null);

  const images = [
    { src: '/images/gallery/abeja_reina.webp', alt: 'Abeja Reina: Híbrido de Ligustica X Carniola' },
    { src: '/images/gallery/criadero_lleno.webp', alt: 'Criaderos de nuestras colmenas en producción' },
    { src: '/images/gallery/abeja_volando_flor.webp', alt: 'El vuelo de una abeja hacia una flor' },
    { src: '/images/gallery/apicultor.webp', alt: 'Rodeados de naturaleza, nos apasiona revisar nuestras colmenas' }
  ];

  const nextSlide = useCallback(() => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  }, [images.length]);

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  // Auto-play de imágenes
  useEffect(() => {
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, [nextSlide]);

  // --- 🎯 LÓGICA DE CENTRADO (CORREGIDA) ---
  useEffect(() => {
    const performCentering = () => {
      // Si la URL tiene #gallery, esperamos un momento y centramos
      if (window.location.hash === '#gallery') {
        setTimeout(() => {
          if (carouselRef.current) {
            carouselRef.current.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
          }
        }, 1200); // 1.2 segundos para ver el título antes de bajar
      }
    };

    // Ejecutar al cargar la página
    performCentering();

    // Escuchar cambios en la URL (clics en el menú)
    window.addEventListener('hashchange', performCentering);

    // Limpieza correcta del evento para que no falle
    return () => window.removeEventListener('hashchange', performCentering);
  }, []);

  const openFullGallery = () => {
    window.open('/full-gallery', '_blank');
  };

  return (
    <section 
      id="gallery" 
      className="scroll-mt-10 pt-10 pb-20 bg-[#FFFBF0] dark:bg-[#1C1B17] transition-colors duration-300"
    >
      <div className="max-w-[110rem] mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Título de Galería */}
        <div className="text-center mb-10">
          <h2 className="text-4xl md:text-5xl font-black text-[#594400] dark:text-[#FFD54F] mb-2 uppercase tracking-tighter">
            Galería
          </h2>
          <div className="w-20 h-1.5 bg-yellow-500 dark:bg-[#FFD54F] mx-auto rounded-full"></div>
        </div>

        {/* 🎞️ CARRUSEL CINEMATOGRÁFICO 21:9 */}
        <div 
          ref={carouselRef}
          className="relative group w-full overflow-hidden rounded-[2rem] md:rounded-[3.5rem] shadow-2xl border-4 md:border-8 border-white dark:border-[#2A2821] transition-all duration-500 aspect-[4/5] md:aspect-[21/9]"
        >
          {images.map((image, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
                index === currentIndex ? 'opacity-100 z-10' : 'opacity-0 z-0'
              }`}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover select-none scale-105 group-hover:scale-100 transition-transform duration-[5s]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent flex items-end justify-start p-8 md:p-20">
                <div className="max-w-4xl">
                   <p className="text-white text-xl md:text-4xl font-extrabold leading-tight drop-shadow-2xl animate-fade-up">
                    {image.alt}
                  </p>
                </div>
              </div>
            </div>
          ))}

          {/* Navegación manual */}
          <button onClick={prevSlide} className="absolute left-6 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-yellow-500 backdrop-blur-md text-white p-4 rounded-full opacity-0 group-hover:opacity-100 transition-all z-30 hidden md:flex">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M15 19l-7-7 7-7" /></svg>
          </button>
          <button onClick={nextSlide} className="absolute right-6 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-yellow-500 backdrop-blur-md text-white p-4 rounded-full opacity-0 group-hover:opacity-100 transition-all z-30 hidden md:flex">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M9 5l7 7-7 7" /></svg>
          </button>
        </div>

        {/* Botón Explorar */}
        <div className="text-center mt-12">
          <button 
            onClick={openFullGallery}
            className="group bg-[#F9A825] dark:bg-[#FFD54F] text-white dark:text-[#1C1B17] px-8 py-3.5 rounded-full font-bold shadow-lg hover:scale-105 transition-all flex items-center gap-3 mx-auto"
          >
            <span>Ver Galería Completa</span>
            <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Gallery;